<template>
  <div class="codeLogin">
    <el-form
      :model="fastDataForm"
      :rules="dataRule1"
      ref="fastDataForm"
      @keyup.enter.native="fastDataFormSubmitHandle()"
    >
      <el-form-item prop="fastPhone">
        <el-input
          v-model="fastDataForm.fastPhone"
          autocomplete="off"
          :placeholder="$t('login.accountPlaceholder')"
          maxlength="20"
        ></el-input>
      </el-form-item>
      <el-form-item prop="fastCaptcha">
        <div class="relative">
          <el-input
            v-model="fastDataForm.fastCaptcha"
            placeholder="请输入验证码"
            maxlength="20"
          ></el-input>
          <el-button
            class="codeBtn"
            type="text"
            @click="sendcode"
            :loading="loading"
            :disabled="disabled"
            >{{ btntxt }}</el-button
          >
        </div>
      </el-form-item>
      <div class="center m-y-40">
        <div>
          <el-button
            class="submitBtn"
            :class="{ disabledSubmitBtn: !agreeChecked }"
            type="primary"
            @click="fastDataFormSubmitHandle"
            >注册</el-button
          >
        </div>
      </div>
      <!-- <div class="center">
        <el-checkbox v-model="agreeChecked" class="submitTip"
          >阅读并同意以下协议<a @click.stop="$emit('userAgree')">{{
            $t('login.servicePolicy')
          }}</a
          ><a @click.stop="$emit('privacyAgree')">{{
            $t('login.userPrivacyPolicy')
          }}</a></el-checkbox
        >
      </div> -->
    </el-form>
  </div>
</template>

<script>
// import { getUUID } from '@/utils'
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { isMobile } from '@/utils/validate'
import { getEnvConfig } from '@/utils/envConfig.js'
import { Base64 } from 'js-base64'

export default {
  data () {
    return {
      agreeChecked: true,
      dataForm: {
        username: '',
        password: '',
        grant_type: 'password',
        appCode: window.SITE_CONFIG.appCode,
        client_id: 'shopping',
        loginType: '0',
        env: getEnvConfig().env,
        domain: getEnvConfig().domain
      },
      fastDataForm: {
        fastPhone: '',
        fastCaptcha: '',
        requestId: '',
        password: ''
      },
      loading: false,
      disabled: false,
      time: 0,
      btntxt: this.$t('login.captchaGet'),
      captchaPath: '',
      routerForm: ''
    }
  },
  computed: {
    dataRule1 () {
      let validateMobile = (rule, value, callback) => {
        if (!isMobile(value)) {
          return callback(
            new Error(
              this.$t('validate.format', { attr: this.$t('user.mobile') })
            )
          )
        }
        callback()
      }
      return {
        fastPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { validator: validateMobile, trigger: 'blur' }
        ],
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        fastCaptcha: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getCaptcha()
  },
  methods: {
    // 快捷手机验证码登录
    fastDataFormSubmitHandle: debounce(
      function () {
        this.$refs['fastDataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          if (!this.agreeChecked) {
            const h = this.$createElement
            this.$msgbox({
              message: h('p', {}, [
                '登录即代表您同意',
                h(
                  'a',
                  {
                    class: 'pointer',
                    on: {
                      click: () => {
                        this.$emit('userAgree')
                      }
                    }
                  },
                  '《Plantmate服务协议》'
                ),
                '与',
                h(
                  'a',
                  {
                    class: 'pointer',
                    on: {
                      click: () => {
                        this.$emit('privacyAgree')
                      }
                    }
                  },
                  '《用户隐私权政策》'
                ),
                '，继续登录吗?'
              ]), // "登录即代表您同意《Plantmate服务协议》与《用户隐私权政策》，继续登录吗?",
              title: '提示',
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'none'
            })
              .then(() => {
                this.agreeChecked = true
              })
              .catch(() => {})
            return
          }
          this.loading = true
          // 后台请求
          this.$http
            .post('/front/mall/v3/login', {
              // params: {
              requestId: this.fastDataForm.requestId,
              messageCode: this.fastDataForm.fastCaptcha,
              mobile: this.fastDataForm.fastPhone,
              password: Base64.encode('123456')
              // }
            })
            .then(({ data: res }) => {
              if (res.code === 0 && typeof res.data === 'string') {
                this.$router.push({
                  name: 'login-registe',
                  query: {
                    mobile: Base64.encode(this.fastDataForm.fastPhone),
                    usernameForValidate: Base64.encode(res.data) // 增加返回参数，注册接口用
                  }
                })
                this.bus.$emit('hideLoginDialog')
              } else if (res.code === 0) {
                Cookies.set('access_token_shop', res.data.access_token)
                Cookies.set('username_shop', res.data.username)
                // 学习平台cookie登录共享
                Cookies.set('access_token_shop', res.data.access_token, {
                  domain: location.origin.includes('plantmate.supcon.com')
                    ? '.supcon.com'
                    : '.plantmate.com'
                })
                Cookies.set('username_shop', res.data.username, {
                  domain: location.origin.includes('plantmate.supcon.com')
                    ? '.supcon.com'
                    : '.plantmate.com'
                })
                this.bus.$emit('getUserMenuPerm')
                this.bus.$emit('hideLoginDialog')
                const redirectUrl = this.toRedirectUrl()
                if (redirectUrl) {
                  setTimeout(() => {
                    window.location.href = redirectUrl
                  }, 300)
                } else {
                  setTimeout(() => {
                    window.location.href = '/'
                  }, 300)
                }
              } else if (res.code === 90001) {
                this.emit('active', this.fastDataForm)
              }
            })
            .catch((err) => {
              this.$message.error(err.message)
            })
            .finally(() => {
              this.loading = false
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 重定向地址
    toRedirectUrl () {
      const redirectUrl = sessionStorage.getItem('redirectUrl')
      if (redirectUrl) {
        sessionStorage.removeItem('redirectUrl')
        // window.location.href = redirectUrl
      }
      return redirectUrl
    },
    // 获取验证码
    getCaptcha () {
      // this.dataForm.uuid = getUUID()
      // this.captchaPath = `${window.SITE_CONFIG['apiURL']}/front/consumer/sysCaptcha/${this.dataForm.uuid}`
    },
    async checkUser () {
      const { data: res } = await this.$http.get(`/front/openapi/user-status?mobile=${this.fastDataForm.fastPhone}`)
      return res.data
    },
    // 手机验证发送验证码
    async sendcode () {
      // const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
      if (this.fastDataForm.fastPhone === '') {
        this.$message({
          message: '手机号不能为空',
          type: 'warning'
        })
        return
      }
      if (!isMobile(this.fastDataForm.fastPhone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else {
        const t = await this.checkUser()
        if (t !== '-1') {
          return this.$message.warning('该手机号已注册，请直接登录')
        }
        this.loading = true
        this.fastDataForm.requestId = ''
        this.disabled = true
        // 快捷登录发送验证码
        this.$http
          .get(
            `/front/consumer/sendVerificationCode?mobile=${this.fastDataForm.fastPhone}`
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.fastDataForm.requestId = res.data.requestId
              this.time = 60
              this.timer()
            } else {
              this.getCaptcha()
              this.disabled = false
            }
          })
          .catch(() => {
            this.disabled = false
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.disabled = true
        this.btntxt = this.time + 's' + this.$t('login.captchaGetAgain')
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.btntxt = this.$t('login.captchaGet')
        this.disabled = false
        this.getCaptcha()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.codeLogin {
  width: 100%;
  padding: 24px;
  padding-top: 40px;
  .relative {
    position: relative;
  }
  .codeBtn {
    position: absolute;
    top: 6px;
    right: 28px;
  }
  .captchaImg {
    width: 100px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 12px;
  }
  .submitBtn {
    width: 183px;
    height: 43px;
    border-radius: 8px;
    background: #2a54d1;
    box-shadow: 0px 4px 10px 0px rgba(116, 183, 255, 0.3);
    display: inline-block;
  }
  .disabledSubmitBtn {
    background-color: #74b7ff;
    opacity: 0.3;
  }
  .submitTip {
    font-family: AlibabaPuHuiTi;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #666666;
    margin-top: 8px;
    ::v-deep .el-checkbox__label {
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      color: #666666;
    }
    a {
      color: #2a54d1;
    }
  }
}
</style>
<style>
.pointer {
  cursor: pointer;
}
</style>
